import React from "react";

import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import BottomFooter from "components/Footer/BottomFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import useStyles from "../styles/styles";
import { Grid, Typography, Box } from "@mui/material";
import { FONT_FAMILY } from "common/sharedFunctions";
import { useTranslation } from "react-i18next";
import { colors } from "components/Theme/WebTheme.js";
import { useNavigate } from "react-router-dom";

import VideoBg from "../components/VideoBg";
const dashboardRoutes = [];

export default function AboutUs(props) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isRTL = i18n.dir();
  const classes = useStyles();
  const { ...rest } = props;

  return (
    <div style={{ margin: "-8px" }}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <VideoBg />
      <Box className={classes.centerContainer}>
        <Grid container spacing={3} className={classes.aboutUsContainer}>
          <Grid item xs={12} md={12} style={{ position: "relative" }}>
            <Typography
              variant="h4"
              fontWeight={700}
              fontFamily={FONT_FAMILY}
              className={classes.homeTitle}
            >
              {t("about_us")}
            </Typography>
            <div
              style={{
                margin: "0px auto",
                display: "flex",
                justifyContent: "center",
                color: "white",
                maxWidth: "60%",
              }}
            >
              <p
                className={
                  isRTL === "rtl"
                    ? classes.rtlDescription
                    : classes.ltrDescription
                }
              >
                {t("about_us_content2")} <br />
                {t("about_us_content1")} <br />
                <br />
                <a
                  style={{
                    cursor: "pointer",
                    color: colors.Header_Background,
                    fontFamily: FONT_FAMILY,
                  }}
                  className={classes.block}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/term-condition");
                  }}
                >
                  {t("term_condition")}
                </a>
                <br />
                <a
                  style={{
                    cursor: "pointer",
                    color: colors.Header_Background,
                    fontFamily: FONT_FAMILY,
                  }}
                  className={classes.block}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/privacy-policy");
                  }}
                >
                  {t("privacy_policy")}
                </a>{" "}
                <br />
              </p>
            </div>
          </Grid>
        </Grid>
      </Box>

      <BottomFooter />
    </div>
  );
}
